import axios from "../../axios";
import { GET_DASHBOARD_REPORT , GET_DASHBOARD_CHART_REPORT} from './dashboardTypes'
import { URL_GET_DASHBOARD_REPORT , URL_GET_DASHBOARD_CHART_REPORT} from './dashboardUrls'
import { ResponseModel, STATUS_OK } from '../../models/network/response_model'
export default {
// eslint-disable-next-line
  [GET_DASHBOARD_REPORT]({ commit }) {
    // let param = new URLSearchParams(item).toString();
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_DASHBOARD_REPORT}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_DASHBOARD_REPORT, data);
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }    
        })
        .catch((error) => { reject(error);})
      })
  },

  [GET_DASHBOARD_CHART_REPORT]({ commit }, item) {
    let param = new URLSearchParams(item).toString();
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_DASHBOARD_CHART_REPORT}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              resolve(data);
            } else {
              commit(GET_DASHBOARD_CHART_REPORT, []);
              reject(resultModel.message)
            }
          } else {
            commit(GET_DASHBOARD_CHART_REPORT, []);
            reject(responseModel.message)
          }
        })
        .catch((error) => { reject(error);})
    })
  },
}
